module.exports = __webpack_public_path__ + "img/nor.0b41df77.svg";